import React from "react";
import { store } from "@redux/store";
import actions from "@redux/EditableTable/actions";
import EquipmentLookup from "@containers/Lookup/EquipmentLookup";
import WorkorderLink from "@containers/facility/Workorder/WorkorderLink";

import _ from "lodash";

import moment from "moment";
import ProjectLookup2 from "@containers/Lookup/ProjectLookup2";
import { Badge, Input, Tooltip, Tag } from "antd";
import WorkorderNotification from "@containers/facility/Workorder/WorkorderNotification";

const { TextArea } = Input;

const STATUS_THEME = {
  Completed: {
    text: "Completed",
    backgroundColor: "#dcfce7",
    borderColor: "#16a34a",
    color: "#14532d",
  },
  Verifying: {
    text: "Verifying",
    backgroundColor: "#dbeafe",
    borderColor: "#2563eb",
    color: "#1d4ed8",
  },
  "On-Hold": {
    text: "On-Hold",
    backgroundColor: "#fef3c7",
    borderColor: "#d97706",
    color: "#92400e",
  },
  InProgress: {
    text: "InProgress",
    backgroundColor: "#fef2f2",
    borderColor: "#f97316",
    color: "#c2410c",
  },
  "Not Started": {
    text: "Not Started",
    backgroundColor: "#f8fafc",
    borderColor: "#94a3b8",
    color: "#475569",
  },
};

export const WorkorderProps = {
  title: "Workorder",
  description: "",
  name: "workorder",
  tableName: "kpiworkorders",
};

export const WorkorderColumns = () => [
  {
    title: "key",
    dataIndex: "id",
    key: "id",
    fixed: "left",
    editable: false,
    search: false,
    importIngore: true,
    hideInTable: false,
    width: 60,
    sorter: (a, b) => a.id - b.id,
  },
  // {
  //     title: 'System',
  //     dataIndex: 'system',
  //     key: 'system',
  //     search: false,
  //     edit: true,
  //     hideInTable: window.innerWidth < 760,
  //     sorter: (a, b) => a.system?.localeCompare(b.system),
  //     formItemProps: {
  //         rules: [
  //             {
  //                 required: true,
  //                 message: 'required',
  //             },
  //         ],
  //     },
  //     renderFormItem: () => <TextArea rows={1}/>,
  // },
  {
    title: "Equipment",
    dataIndex: "equipment_name",
    key: "equipment_name",
    edit: true,
    hideInTable: true,
    type: "select",
    valueType: "select",
    sorter: (a, b) => a.equipment?.localeCompare(b.equipment),
    render: (text, record) => _.get(record, "equipment_name"),
    renderFormItem: () => <EquipmentLookup />,
    // renderFormItem: (_, { isEditable }) => {
    //     let value = _.entity.equipment
    //     return <EquipmentLookup value={value}/>
    // },
  },
  {
    title: "Equipment",
    dataIndex: "equipment",
    key: "equipment",
    edit: true,
    width: 100,
    type: "select",
    valueType: "select",
    sorter: (a, b) => a.equipment - b.equipment,
    hideInTable: window.innerWidth < 760,
    render: (text, record) => _.get(record, "equipment_name"),
    renderFormItem: (_, { isEditable }) => {
      let record = _.entity.equipment_name ? _.entity.equipment_name : "";
      return <EquipmentLookup record={record} />;
    },
  },

  {
    title: "Issue",
    dataIndex: "issue",
    key: "issue",
    width: 200,
    fixed: "left",
    search: false,
    edit: true,
    sorter: (a, b) => a.issue?.localeCompare(b.issue),
    formItemProps: {
      rules: [
        {
          required: true,
          message: "required",
        },
      ],
    },
    render: (text, record, _, action) => (
      <WorkorderLink id={record.id} text={text} action={action} />
    ),
    renderFormItem: () => <TextArea rows={1} />,
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: 200,
    edit: true,
    required: false,
    search: false,
    hideInTable: false,
    render: (text) => (
      <Tooltip title={text}>
        <div style={{ 
          overflow: 'hidden', 
          textOverflow: 'ellipsis', 
          whiteSpace: 'nowrap',
          width: '100%'
        }}>
          {text}
        </div>
      </Tooltip>
    ),
    renderFormItem: () => <TextArea rows={1} />,
  },
  {
    title: "Recommended Action",
    dataIndex: "recommended_action",
    key: "recommended_action",
    edit: true,
    width: 100,
    sorter: (a, b) =>
      a?.recommended_action?.localeCompare(b?.recommended_action),
    renderFormItem: () => <TextArea rows={1} />,
    render: (text, record) => {
      const recommendedAction = record.recommended_action;
      return (
        <Tooltip placement="topLeft" title={recommendedAction}>
          <>{recommendedAction}</>
        </Tooltip>
      );
    },
  },
  {
    title: "Responsible Party",
    dataIndex: "responsible_party",
    key: "responsible_party",
    edit: true,
    width: 80,
    sorter: (a, b) => a.responsible_party?.localeCompare(b.responsible_party),
    render: (text, record) => {
      const responsibleParty = record.responsible_party;
      return (
        <Tooltip placement="topLeft" title={responsibleParty}>
          <>{responsibleParty}</>
        </Tooltip>
      );
    },
  },
  {
    title: "Assign To",
    dataIndex: "assignTo_name",
    key: "assignTo_name",
    edit: true,
    width: 80,
    sorter: (a, b) => a.assignTo_name?.localeCompare(b.assignTo_name),
  },
  {
    title: "WorkOrder Number",
    dataIndex: "workordernumber",
    key: "workordernumber",
    width: 80,
    search: false,
    edit: true,
    sorter: (a, b) => a.workordernumber?.localeCompare(b.workordernumber),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    edit: true,
    width: 100,
    align: "left", // 状态列左对齐
    render: (text, record) => {
      const dueDate = record?.due_date;
      const statusText = record?.status || "Not Started";
      const theme = STATUS_THEME[statusText] || STATUS_THEME["Not Started"];
      const tagStyle = {
        backgroundColor: theme.backgroundColor,
        borderColor: theme.borderColor,
        color: theme.color,
        fontWeight: 600,
        letterSpacing: 0.2,
        minWidth: 96,
        textAlign: "center",
      };
      const isOverDue =
        statusText !== "Completed" &&
        dueDate &&
        moment(dueDate).isValid() &&
        moment(dueDate).isBefore(moment(), "day");

      return (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Tag style={tagStyle}>{theme.text}</Tag>
          {isOverDue ? (
            <Tag
              color="#ff4d4f"
              style={{
                backgroundColor: "#fff1f0",
                borderColor: "#ff4d4f",
                color: "#a8071a",
                fontWeight: 600,
              }}
            >
              Over Due
            </Tag>
          ) : null}
        </div>
      );
    },
    sorter: (a, b) => a.status?.localeCompare(b.status),
    valueEnum: {
      "Not Started": { text: "Not Started" },
      InProgress: { text: "InProgress" },
      "On-hold": { text: "On-hold" },
      Verifying: { text: "Verifying" },
      Completed: { text: "Completed" },
    },
    formItemProps: {
      initialValue: "",
    },
  },
  {
    title: "Priority",
    dataIndex: "priority",
    key: "priority",
    width: 60,
    align: "left", // 状态列左对齐
    edit: true,
    sorter: (a, b) => a.priority?.localeCompare(b.priority),
    render: (text, record) => {
      let style = {
        backgroundColor: "#f0f0f0",
      };
      let statusText = record?.priority;
      if (statusText === "Urgent") {
        style = {
          color: "#ef4444",
          backgroundColor: "#f0f0f0",
        };
      } else if (statusText === "Important") {
        style = {
          color: "#fb923c",
          backgroundColor: "#f0f0f0",
        };
      } else if (statusText === "Low") {
        style = {
          color: "#4ade80",
          backgroundColor: "#f0f0f0",
        };
      }

      return (
        <Tag
          style={{ ...style, fontSize: "14px" }}
          className="align-center py-1 px-2 bold"
        >
          {statusText}
        </Tag>
      );
    },
    valueEnum: {
      Urgent: { text: "Urgent" },
      Important: { text: "Important" },
      Low: { text: "Low" },
    },
    formItemProps: {
      initialValue: "Low",
    },
  },
  {
    title: "Energy Impact",
    dataIndex: "energy_impact",
    key: "energy_impact",
    edit: true,
    width: 80,
    align: "left", // 状态列左对齐
    sorter: (a, b) => a.energy_impact?.localeCompare(b.energy_impact),
    valueEnum: {
      High: { text: "High" },
      Medium: { text: "Medium" },
      Low: { text: "Low" },
      None: { text: "None" },
    },
    formItemProps: {
      initialValue: "Medium",
    },
  },
  {
    title: "Project",
    dataIndex: "project_name",
    key: "project",
    edit: true,
    width: 100,
    type: "select",
    valueType: "select",
    hideInTable: false,
    render: (text, record) => _.get(record, "project_name.name"),
    renderFormItem: (_, { isEditable }) => {
      let record = _.entity.project_name ? _.entity.project_name.name : "";
      return <ProjectLookup2 record={record} />;
    },
  },
  {
    title: "Complete Date",
    dataIndex: "complete_date",
    edit: true,
    type: "date",
    width: 90,
    hideInTable: false,
    className: "date-editor",
    key: "complete_date",
    align: "right", // 时间列右对齐
    sorter: (a, b) => a.complete_date?.localeCompare(b.complete_date),
    renderFormItem: () => <Input type={"date"} />,
  },
  {
    title: "Reported By",
    dataIndex: "reportBy",
    hideInTable: false,
    width: 90,
    className: "date-editor",
    key: "reportBy",
    render: (text) => (
      <Tooltip title={text}>
        <div style={{ 
          overflow: 'hidden', 
          textOverflow: 'ellipsis', 
          whiteSpace: 'nowrap',
          width: '100%'
        }}>
          {text}
        </div>
      </Tooltip>
    ),
    renderFormItem: () => <Input />,
  },
  {
    title: "Report Date",
    dataIndex: "reportDate",
    edit: true,
    type: "date",
    width: 90,
    className: "date-editor",
    key: "reportDate",
    sorter: (a, b) => a.reportDate?.localeCompare(b.reportDate),
    renderFormItem: () => <Input type={"date"} />,
    hideInTable: true,
  },
  {
    title: "Report Date",
    dataIndex: "reportDate",
    key: "reportDate",
    width: 90,
    hideInTable: false,
    editable: false,
    importIngore: true,
    align: "right", // 时间列右对齐
    sorter: (a, b) => a.reportDate?.localeCompare(b.reportDate),
    render: (text, record) => moment(record.reportDate).format("YYYY-MM-DD"),
  },
  {
    title: "Create Date",
    dataIndex: "created_date",
    key: "created_date",
    width: 90,
    hideInTable: false,
    editable: false,
    importIngore: true,
    align: "right", // 时间列右对齐
    sorter: (a, b) => a.created_date - b.created_date,
    render: (text, record) => moment(record.created_date).format("YYYY-MM-DD"),
  },
  {
    title: "Due Date",
    dataIndex: "due_date",
    key: "due_date",
    width: 90,
    hideInTable: false,
    editable: false,
    importIngore: true,
    align: "right",
    sorter: (a, b) => a.due_date - b.due_date,
    render: (text, record) =>
      record?.due_date ? moment(record.due_date).format("YYYY-MM-DD") : "",
  },
  {
    title: "CreatedBy",
    dataIndex: "createdby_name",
    key: "createdby_name",
    editable: false,
    width: 90,
    search: false,
    importIngore: true,
    hideInTable: false,
    render: (text, record) => {
      const createdByName = record.createdby_name;
      return (
        <Tooltip placement="topLeft" title={createdByName}>
          <>{createdByName}</>
        </Tooltip>
      );
    },
  },
  {
    title: "Modify Date",
    dataIndex: "modified_date",
    key: "modified_date",
    width: 90,
    editable: false,
    search: false,
    align: "right", // 时间列右对齐
    sorter: (a, b) => a.modified_date - b.modified_date,
    importIngore: true,
    render: (text, record) => moment(record.modified_date).format("YYYY-MM-DD"),
  },

  {
    title: "ModifiedBy",
    dataIndex: "lastModified_name",
    key: "lastModified_name",
    editable: false,
    search: false,
    width: 90,
    importIngore: true,
    hideInTable: false,
    render: (text, record) => {
      const lastModifiedName = record.lastModified_name;
      return (
        <Tooltip placement="topLeft" title={lastModifiedName}>
          <>{lastModifiedName}</>
        </Tooltip>
      );
    },
  },
  {
    title: "Comments",
    valueType: "option",
    width: 50,
    fixed: "right",
    importIngore: true,
    render: (text, record, _, action) => (
      <div className="pl-2">
        <WorkorderNotification record={record} />
        {record?.has_attachment ? (
          <Badge>
            <i
              className="fas fa-paperclip text-primary text-2xl "
              style={{ color: '#3A3F63', fontSize: "12px", marginLeft: 4 }}
            ></i>
          </Badge>
        ) : (
          ""
        )}
      </div>
    ),
  },

  {
    title: "modified_date",
    dataIndex: "modified_date",
    key: "modified_date",
    editable: false,
    search: false,
    importIngore: true,
    hideInTable: true,
  },
];
